import * as S from "@/components/Dashboard/styled";
import { StyledTitle } from "@/components/Dashboard/styled";
import { CONTENT_WIDTH } from "@/enums";
import { Pager } from "@/sharedStyled";
import { Button, Card, Col, Row, Spin, Table } from "antd";
import { arrayOf, bool, func, number, object, string } from "prop-types";
import { useIntl } from "react-intl";

const NONE = 0;
const DEFAULT_PAGE = 1;

const DashboardTableFullViewView = ({
  data,
  isFetching,
  title,
  titleRoute,
  totalCount,
  columns,
  queryParams,
  setQueryParams,
  handleChange,
  pageSize,
}) => {
  const intl = useIntl();

  return (
    <Row>
      <Col span={CONTENT_WIDTH.max}>
        <Card
          title={
            <>
              <S.CardStatistic level={2}>
                {isFetching ? <Spin /> : data && (totalCount || NONE)}
              </S.CardStatistic>
              <StyledTitle to={titleRoute}>{title}</StyledTitle>
            </>
          }
          extra={
            <Button
              data-test-id="dashboard-clear-filters"
              onClick={() => {
                setQueryParams({}, "push");
              }}
            >
              {intl.formatMessage({ id: "general.clearFilters" })}
            </Button>
          }
        >
          <Table
            data-test-id="dashboard-full-table"
            columns={columns}
            dataSource={data}
            rowKey={({ id }) => id}
            loading={isFetching}
            onChange={handleChange}
            pagination={false}
            scroll={{ x: true }}
          />
          <Pager
            defaultCurrent={queryParams.page || DEFAULT_PAGE}
            current={queryParams.page || DEFAULT_PAGE}
            pageSize={pageSize}
            total={totalCount}
            showSizeChanger={false}
            onChange={(page) => setQueryParams({ page })}
            data-test-id="dashboard-table-full-pagination"
          />
        </Card>
      </Col>
    </Row>
  );
};

DashboardTableFullViewView.propTypes = {
  data: arrayOf(object).isRequired,
  isFetching: bool.isRequired,
  title: string.isRequired,
  titleRoute: string.isRequired,
  totalCount: number.isRequired,
  columns: arrayOf(object).isRequired,
  queryParams: object.isRequired,
  setQueryParams: func.isRequired,
  handleChange: func.isRequired,
  pageSize: number.isRequired,
};

export default DashboardTableFullViewView;
